module.exports = __webpack_public_path__ + "img/afrus_logo_2.47a7f61a.png";